import Vue from "vue";
import * as rt from "../../../routes/routes";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router";

export const actions = {
  newStation({ commit }) {
    let stationDetail = {
      station_name: $(".station_name").val()
    };
    $(".creatingStation").hide();
    $(".creatingStationLoader").show();
    baseurl.post(rt.newStation, stationDetail).then(res => {
      $(".creatingStation").show();
      $(".creatingStationLoader").hide();

      if (res.data.code === 200) {
        window.$("#new-station").modal("hide");
        $(".form-control").val("");
        suc.stationsCreateSuccess();
        setTimeout(() => {
          commit("STORE_STATIONS", res.data.stations);
        }, 1000);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.StationsExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingStations();
      } else if (res.data.code === 405) {
        window.$("#new-station").modal("hide");
        $(".form-control").val("");
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        $(".form-control").val("");
        ses.sessionComplete();
      }
    });
  },

  loadStations({ commit }) {
    baseurl.get(rt.loadStations).then(res => {
      $(".stationsLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_STATIONS", res.data.stations);
      } else if (res.data.code === 404) {
        ers.errorLoadingStations();
      } else if (res.data.code === 405) {
        commit("STORE_STATIONS", []);
        ers.noPermissionToRead();
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/stations/actions.js